import clsx from "clsx";

interface DividerProps {
  label?: string;
  strong?: boolean;
  vertical?: boolean;
  /** Full to use w-full/h-full */
  length?: "full" | number
}

const Divider = ({
  label, strong = false, vertical = false, length = 300,
}: DividerProps) => {
  const baseStyle = `rounded-xs typography-small-base text-text-subtle ${strong ? "bg-border-strong" : "bg-border-base"}`;

  if (vertical) {
    if (label) {
      // Vertical with label
      return (
        <div className={clsx("w-fit flex flex-col", length === "full" && "h-full")} style={{ height: length }}>
          <div className={`flex-1 w-px mx-auto ${baseStyle}`} />
          <div className="py-2">{label}</div>
          <div className={`flex-1 w-px mx-auto ${baseStyle}`} />
        </div>
      );
    }
    // Vertical without label
    return <div className={clsx(`w-px ${baseStyle}`, length === "full" && "h-full")} style={{ height: length }}>{label}</div>;
  }
  if (label) {
    // Horizontal with label
    return (
      <div className={clsx("flex flex-row items-center", length === "full" && "w-full")} style={{ width: length }}>
        <div className={`flex-1 h-px ${baseStyle}`} />
        <span className="px-4">{label}</span>
        <div className={`flex-1 h-px ${baseStyle}`} />
      </div>
    );
  }
  // Horizontal without label
  return <div className={clsx(`h-px ${baseStyle}`, length === "full" && "h-full")} style={{ width: length }} />;
};

export default Divider;
